export default {
    PACIENTE: 1,
    CNS: 2,
    CPF: 3,
    PRIORIDADE: 4,
    TIPO_DE_SOLICITACAO: 5,
    TEMPO_MEDIO_PREVISTO_PARA_ATENDIMENTO: 6,
    TEMPO_DE_ESPERA: 7,
    DATA_DA_MOVIMENTACAO: 8,
    STATUS: 9,
    DATA_DO_ATENDIMENTO: 10,
    CLASSIFICACAO: 11,
    PROCEDIMENTO_CONSULTA: 12,
    DATA_DA_SOLICITACAO: 13,
    OBSERVACAO: 14,
}